module.exports = __webpack_public_path__ + "static/media/first-page-slide1.a6b402d8.jpg";